module.exports = __webpack_public_path__ + "new-5455795b/template-7-2x-0fa063e00a1cbd689dcd24133b083cb5.jpg";